import { stringify } from 'query-string';

import { BASE_URL_V3 } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'REWARDS_HOME_GET',
  GET_SUCCESS: 'REWARDS_HOME_GET_SUCCESS',
  GET_FAILURE: 'REWARDS_HOME_GET_FAILURE',
  INVALIDATE_ITEM: 'INVALIDATE_ITEM',
};

export const get = actions.get(
  (studentId, query) =>
    `${BASE_URL_V3}/students/${studentId}/rewards-home/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const invalidateItem = (id, query) => ({
  type: ACTIONS.INVALIDATE_ITEM,
  payload: {
    id,
    query,
  },
});
